import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Shared } from '@rubii/frontend-common';
import { Dsps } from '@rubii/share/src/constants';
import { ClientService } from '../../services/client.service';

@Component({
  selector: 'app-sso',
  templateUrl: './sso.component.html',
  styleUrls: ['./sso.component.scss']
})
export class SsoComponent implements OnInit {

  @Input() dspIds: number[] = [];
  @Output() switchToEmail = new EventEmitter<void>();

  hasEntra = false;
  hasGoogleSso = false;

  constructor(private router: Router, private client: ClientService) { }

  ngOnInit(): void {
    this.hasEntra = this.dspIds.includes(Dsps.ENTRA);
    this.hasGoogleSso = this.dspIds.includes(Dsps.GOOGLE_SSO);
  }

  loginWithEmail(): void {
    Shared.helpers.CookieHelper.deleteCookie('sso-domain');
    this.switchToEmail.emit();
  }

  async continueWithEntra() {
    const redirectUrl = await this.client.user.generateSSOLoginUrl(window.location.hostname, Dsps.ENTRA, 'Entra');
    window.location.href = redirectUrl;
  }

  async continueWithGoogleSso() {
    const redirectUrl = await this.client.user.generateSSOLoginUrl(window.location.hostname, Dsps.GOOGLE_SSO, 'Google');
    window.location.href = redirectUrl;
  }
}
